"use client";

import { MultiStepForm } from './components/MultiStepForm';
import { termLoanEnquireFormConfig } from './TermLoanEnquireFormConfig';

export function TermLoanEnquireForm() {
  return (
    <MultiStepForm 
      config={termLoanEnquireFormConfig}
      className="term-loan-form"
    />
  );
} 